import React from "react";
import Container from "@/components/marketing/Container";
import { Link } from "react-router-dom";
import { useAuth } from "@/lib/AuthContext";
import Reveal from "@/components/marketing/Reveal";

export default function CTASection({ eyebrow = "Get Started Today", headline = "Ready to distribute your story?", subtitle = "Reach 1,700+ outlets and 100,000+ journalists worldwide. One platform, every channel, no lock-ins.", primaryTo, hidePackagesLink = false }) {
  const { isAuthenticated } = useAuth();
  const resolvedPrimaryTo = primaryTo || (isAuthenticated ? "/dashboard/new-order" : "/register");
  const isExternal = typeof resolvedPrimaryTo === "string" && /^https?:\/\//.test(resolvedPrimaryTo);

  return (
    <section className="py-11 lg:py-[72px]">
      <Container>
        <Reveal>
          <div
          className="text-center rounded-[28px] p-10 lg:p-16"
          style={{
            background: "linear-gradient(160deg, rgba(139,92,246,0.12), rgba(255,255,255,0.5))",
            backdropFilter: "blur(24px)",
            WebkitBackdropFilter: "blur(24px)",
            border: "1px solid rgba(139,92,246,0.25)",
            boxShadow: "0 20px 50px rgba(109,40,217,0.12), inset 0 1px 0 rgba(255,255,255,0.9)",
          }}
        >
          <div className="text-[11px] font-semibold uppercase tracking-[0.18em] text-[#6d28d9] mb-3.5">{eyebrow}</div>
          <h2 className="font-heading text-[clamp(32px,4vw,46px)] font-[650] tracking-[-0.03em] leading-[1.06] mb-3.5 text-heading-gradient">
            {headline}
          </h2>
          <p className="text-[16px] leading-[1.55] text-[#6c6c74] max-w-[440px] mx-auto mb-7">
            {subtitle}
          </p>
          <div className="flex items-center justify-center gap-3">
            {isExternal ? (
              <a href={resolvedPrimaryTo} data-track-label="get_started" data-track-section="cta_band"
                className="inline-block text-[14px] font-semibold px-6 py-[13px] rounded-[14px] bg-brand-gradient text-white whitespace-nowrap transition-opacity hover:opacity-90"
                style={{ boxShadow: "0 8px 20px rgba(124,58,237,0.35)" }}>
                Get Started →
              </a>
            ) : (
              <Link to={resolvedPrimaryTo} data-track-label="get_started" data-track-section="cta_band"
                className="inline-block text-[14px] font-semibold px-6 py-[13px] rounded-[14px] bg-brand-gradient text-white whitespace-nowrap transition-opacity hover:opacity-90"
                style={{ boxShadow: "0 8px 20px rgba(124,58,237,0.35)" }}>
                Get Started →
              </Link>
            )}
            <Link to="/contact" data-track-label="talk_to_team" data-track-section="cta_band"
              className="inline-block text-[14px] font-semibold px-6 py-[13px] rounded-[14px] bg-dark-pill text-white whitespace-nowrap transition-colors hover:bg-[#3c3c42]">
              Talk to Our Team
            </Link>
          </div>
          {!hidePackagesLink && (
            <div className="mt-4.5">
              <Link to="/packages" data-track-label="view_packages" data-track-section="cta_band"
                className="text-[13px] font-semibold text-[#6d28d9] hover:opacity-80 transition-opacity">
                or explore our packages
              </Link>
            </div>
          )}
          </div>
        </Reveal>
      </Container>
    </section>
  );
}